/** Hashes used by the public website shell (menu anchors, skip-link, brand home). */
export function isStorefrontShellHash(hash: string): boolean {
  const h = hash.startsWith('#') ? hash : `#${hash}`;
  return (
    h === '#main-content'
    || h === '#top'
    || h.startsWith('#website-module-')
    || h.startsWith('#website-slot-')
    || h.startsWith('#website-catalog-')
  );
}

/**
 * Drop storefront hashes before React mounts targets. Otherwise the browser
 * scrolls to #main-content / module anchors after splash unlocks (looks like
 * a scroll-down, then a late “refresh”).
 */
export function neutralizeStorefrontShellHash(): void {
  try {
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
  } catch {
    /* ignore */
  }
  if (!isStorefrontShellHash(window.location.hash)) return;
  window.history.replaceState(
    null,
    '',
    `${window.location.pathname}${window.location.search}`,
  );
}
